import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { Observable, ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import {
  Municipality,
  UpdateDataTokenCode,
} from 'src/app/shared/class/update-data';
import {
  ContactMedium,
  DataSelects,
  IdName,
  WaysFindOut,
} from 'src/app/shared/interfaces/data-selects';
import {
  StepInitResponse,
  StepWelcome,
} from 'src/app/shared/interfaces/step-data';
import { PrivacyTermsComponent } from 'src/app/shared/privacy-terms/privacy-terms.component';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

@Component({
  selector: 'app-step-bienvenida',
  templateUrl: './step-bienvenida.component.html',
  styleUrls: ['./step-bienvenida.component.scss'],
})
export class StepBienvenidaComponent extends AutoUnsubscribeComponent implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataWelcome!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepWelcomeSavedEvent = new EventEmitter<boolean>();
  @ViewChild('singleSelect') singleSelect!: MatSelect;

  public formStepWelcome!: FormGroup;
  public requestNumber = '';
  protected _onDestroy = new Subject<void>();
  public emailCtrl: FormControl = new FormControl('');
  public country: string | undefined;
  public waysFindOuts: WaysFindOut[] = [];
  public contactsMedium: ContactMedium[] = [];

  public municipalities: Municipality[] = [];
  public referalQr!: string;
  public qr!: boolean;
  public referralCode!: string;
  public creditTypeUpdate!: string;
  public municipalitiesCtrl: FormControl = new FormControl();
  public municipalitiesFilterCtrl: FormControl = new FormControl();
  public filteredMunicipalities: ReplaySubject<Municipality[]> =
    new ReplaySubject<Municipality[]>(1);
  public referallId!: string;
  public campaign!: string;

  phoneCountryCode = [
    {
      countryCode: 'CO',
      phoneCode: '+57',
      flag: '../../../assets/country-flags/bandera-colombia.png',
    },
    {
      countryCode: 'MX',
      phoneCode: '+52',
      flag: '../../../assets/country-flags/bandera-mexico.png',
    },
  ];

  constructor(
    private frmBuilder: FormBuilder,
    private postDataService: PostDataService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private putDataService: PutDataService,
    private activatedRouter: ActivatedRoute
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.requestNumber = params['requestNumber'];
      this.referalQr = params['referall'];
      this.referralCode = params['referralCode'];
      this.referallId = params['referallId'];
      this.campaign = params['campaign'];
    });
  }

  getNow(): Date {
    return new Date();
  }

  ngOnInit(): void {
    const EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,6}$/;
    const MOBILE = /^[0-9]{10}$/;

    this.formStepWelcome = this.frmBuilder.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.minLength(2),
          Validators.pattern(/^\S+( \S+)*$/),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.minLength(2),
          Validators.pattern(/^\S+( \S+)*$/),
        ],
      ],
      secondLastName: [
        '',
        [
          Validators.maxLength(45),
          Validators.minLength(2),
          Validators.pattern(/^\S+( \S+)*$/),
        ],
      ],
      mobilePhoneNumber: [
        '',
        [Validators.required, Validators.pattern(MOBILE)],
      ],
      privacyNoticeAccepted: ['', [Validators.requiredTrue]],
      dateOfBirth: ['', [Validators.required]],
      whereFindOutId: [
        {
          value: '',
          disabled: (this.referralCode || this.referallId) ? true : false,
        },
        [Validators.required],
      ],
      anotherWayFindOut: ['', [Validators.maxLength(45)]],
      contactMediumType: ['', [Validators.required]],
      cellPhoneCountryCode: ['', [Validators.required]],
    });

    this.emailCtrl.setValidators([
      Validators.required,
      Validators.pattern(EMAIL),
      FormsValidators.validateEmailEnd(),
    ]);
    this.municipalitiesCtrl.setValidators([Validators.required]);

    this.municipalitiesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterMunicipalities();
      });

    if (this.requestFormService.getDataForm().requestNumber) {
      this.loadUpdateFormStepWelcome();
      this.emailCtrl.disable();
      this.formStepWelcome.controls['mobilePhoneNumber'].disable();

      const disableWaysFindOuts = this.waysFindOuts.find(
        (qr) => qr.name == this.referalQr
      );
      if (disableWaysFindOuts) {
        this.formStepWelcome.controls['whereFindOutId'].disable();
      }

      if (
        this.requestFormService.getUpdateForm().welcome.whereFindOut.name ===
        'Referido'
      ) {
        this.formStepWelcome.controls['whereFindOutId'].disable();
      }
    }

    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepWelcome.dirty || this.municipalitiesCtrl.dirty) {
          this.saveStepWelcome();
        } else {
          this.stepWelcomeSavedEvent.emit(true);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataWelcome']?.currentValue) {

      let visibleWaysFindOut: WaysFindOut[] = [];

      visibleWaysFindOut = this.dataWelcome.waysFindOut.filter((ways) => ways.visible === true);

      const visibleWaysFindOutFalse = this.dataWelcome.waysFindOut;

      this.waysFindOuts = this.dataWelcome.waysFindOut
        .filter((ways) => (this.referallId || this.referalQr) ? visibleWaysFindOutFalse : visibleWaysFindOut.includes(ways)
        )
        .sort((a, b) => a.name.localeCompare(b.name));
      const waysFindOutsOther = this.dataWelcome.waysFindOut.find(
        (act) => act.name == 'OTRA (Especifique)'
      );
      if (waysFindOutsOther) {
        this.waysFindOuts.push(waysFindOutsOther);
      }

      const waysFindOut = this.waysFindOuts.find(
        (referall) => referall.name == this.referalQr
      );
      if (waysFindOut) {
        this.formStepWelcome.controls['whereFindOutId'].setValue(
          waysFindOut.id
        );
        this.formStepWelcome.controls['whereFindOutId'].disable();
      }

      const waysFindOutId = this.waysFindOuts.find(
        (referallId) => referallId.id == this.referallId
      );
      if (waysFindOutId) {
        this.formStepWelcome.controls['whereFindOutId'].setValue(
          waysFindOutId.id
        );
        this.formStepWelcome.controls['whereFindOutId'].disable();
      }

      if (this.referralCode) {
        const referido = this.dataWelcome.waysFindOut.find(
          (ways) => ways.name == 'Referido'
        );
        if (referido) {
          this.formStepWelcome.controls['whereFindOutId']!.setValue(
            referido.id
          );
        }
      }

      this.municipalities = this.dataWelcome.municipalities.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      this.contactsMedium = this.dataWelcome.contactMedium;
      this.filteredMunicipalities.next(this.municipalities.slice());

      if (!this.municipalitiesCtrl.value) {
        this.municipalitiesCtrl.setValue(
          this.municipalities.find((x) => x.name == 'Ninguno')?.id
        );
      }

      const phoneCode = this.phoneCountryCode.find(
        (op) => op.countryCode == 'MX'
      );
      if (phoneCode) {
        this.formStepWelcome.controls['cellPhoneCountryCode'].setValue(
          phoneCode.countryCode
        );
      }
    }
  }

  checkEvent() {
    this.formValidEvent.emit(
      this.formStepWelcome.valid &&
      !this.emailCtrl.invalid &&
      !this.municipalitiesCtrl.invalid
    );
  }

  getStepWelcomeObject(): StepWelcome {
    return {
      ...this.formStepWelcome.value,
      dateOfBirth: new Date(
        this.formStepWelcome.value.dateOfBirth
      ).toLocaleDateString('en-CA'),
      whereFindOutId: this.formStepWelcome.get('whereFindOutId')?.value,
      mobilePhoneNumber: this.formStepWelcome.get('mobilePhoneNumber')?.value,
      email: this.emailCtrl.value,
      referredBy: this.referralCode,
      campaign: this.campaign,
      contactMediumType: this.formStepWelcome.get('contactMediumType')?.value,
      delegation: this.municipalities.find(
        (i) => i.id == this.municipalitiesCtrl.value
      )?.name,
      otherMunicipalityId: this.municipalitiesCtrl.value,
      cellPhoneCountryCode: this.formStepWelcome.get('cellPhoneCountryCode')
        ?.value,
    };
  }

  saveStepWelcome() {
    if (
      this.requestFormService.getDataForm().requestNumber ||
      this.requestNumber
    ) {
      const putUpdateRequestWelcome$ = this.putDataService
        .putUpdateRequestWelcome(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStepWelcomeObject()
        )
        .subscribe(() => {
          this.stepWelcomeSavedEvent.emit(true);
        });
      this.subscriptions.push(putUpdateRequestWelcome$);
    } else {
      if (!this.formStepWelcome.valid) {
        FormsValidators.markFormGroupTouched(this.formStepWelcome);
      }
      const postSaveDataWelcome$ = this.postDataService
        .postSaveDataWelcome(
          this.getCountry().toUpperCase(),
          this.getStepWelcomeObject()
        )
        .subscribe({
          next: (resp) => {
            this.requestNumber = resp.requestNumber;
            sessionStorage.setItem('requestNumber', this.requestNumber);
            sessionStorage.setItem('email', this.emailCtrl.value);
            sessionStorage.setItem('applicationId', resp.id);
            this.emailCtrl.disable();
            this.stepWelcomeSavedEvent.emit(true);
            this.formStepWelcome.controls['mobilePhoneNumber'].disable();
            this.openRequestInformationDialog(undefined, resp);
          },
          error: (err) => {
            this.openRequestInformationDialog(err);
          },
        });
      this.subscriptions.push(postSaveDataWelcome$);
    }
  }

  openRequestInformationDialog(
    error?: HttpErrorResponse,
    event?: StepInitResponse
  ) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorValidationError = `ValidationError`.match(
      error?.error.errors[0].code
    );

    const errorCodeEmailInUse = `EMAIL_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorCodePhoneRepeat = `PPHONE_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorEmailFormat = `Email must be a valid email address`.match(
      error?.error.errors[0].message
    );

    if (errorCodeEmailInUse) {
      errorMessage = `Ya ha sido realizado una solicitud con el correo electrónico que nos proporcionaste.\n
      Si desea retomar su solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    if (errorCodePhoneRepeat) {
      errorMessage = `Ya ha sido realizada una solicitud con el teléfono celular que nos proporcionaste.
      \nSi desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    if (errorValidationError && errorEmailFormat) {
      errorMessage = `Ingrese un formato de email correcto.`;
    }

    if (
      errorValidationError &&
      error?.error.errors[0].field === 'dateOfBirth'
    ) {
      errorMessage = `Ingrese un formato de fecha correcto.`;
    }

    if (event) {
      errorMessage = `Su solicitud se ha registrado con el número: <strong>${event.requestNumber}</strong>.
         \nPara localizarla y/o continuar con su registro deberá utilizar este número y su correo registrado.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90vh';
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  loadUpdateFormStepWelcome() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.emailCtrl.setValue(this.requestFormService.getUpdateForm().email);
    this.municipalitiesCtrl.setValue(
      this.requestFormService.getUpdateForm().welcome.delegation
    );
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.formStepWelcome.patchValue({
      firstName: value.welcome.firstName,
      lastName: value.welcome.lastName,
      secondLastName: value.welcome.secondLastName,
      mobilePhoneNumber: value.welcome.cellPhoneCountryCode,
      privacyNoticeAccepted: value.privacyNoticeAccepted,
      dateOfBirth: value.welcome.dateOfBirth ? value.welcome.dateOfBirth : '',
      delegation: value.welcome.delegation,
      whereFindOutId: value.welcome.whereFindOut.id,
      anotherWayFindOut: value.welcome.anotherWayFindOut,
      contactMediumType: value.welcome.contactMedium,
      cellPhoneCountryCode: value.welcome.phoneCountryCode.countryCode,
    });
  }

  isLetter(evt: KeyboardEvent) {
    if (
      evt.code != 'Space' &&
      evt.code != 'Backspace' &&
      evt.code != 'Delete' &&
      evt.code != 'ArrowLeft' &&
      evt.code != 'ArrowRight' &&
      evt.code != 'Tab' &&
      (evt.keyCode < 65 || (evt.keyCode > 90 && evt.keyCode != 192))
    )
      evt.preventDefault();
  }

  openNoticeOfPrivacyDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = '90vh';
    const dialogSubscription$ = this.dialog
      .open(PrivacyTermsComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
    this.subscriptions.push(dialogSubscription$);
  }

  validInputAnotherWayFindOut({
    isUserInput,
    source,
  }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }

    const otherWhereFindOutValidators =
      source.value === 'f166537b-a8f5-4bd5-b71c-651173b768be'
        ? [Validators.required]
        : [];

    this.formStepWelcome.controls['anotherWayFindOut'].setValidators(
      otherWhereFindOutValidators
    );

    this.formStepWelcome.controls['anotherWayFindOut'].updateValueAndValidity();
  }

  deleteSpaceInit(evt: KeyboardEvent) {
    evt.target?.addEventListener('keyup', (e: any) => {
      const string = e.target!.value;
      e.target.value = string.trimStart();
    });
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  protected filterMunicipalities() {
    if (!this.municipalities) {
      return;
    }
    let search = this.municipalitiesFilterCtrl.value;
    if (!search) {
      this.filteredMunicipalities.next(this.municipalities.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredMunicipalities.next(
      this.municipalities.filter(
        (municipality) => municipality.name.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected setInitialValue() {
    this.filteredMunicipalities
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: IdName, b: IdName) =>
          a && b && a.id === b.id;
      });
  }
}
